import { createAction } from '@reduxjs/toolkit';
import { useState } from 'react';
import { useSelector } from 'react-redux';

import { authenticatedJsonFetch } from '@perpay-web/authentication/authenticatedJsonFetch';
import { HTTPMethod } from '@perpay-web/constants/httpMethods';
import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';
import { getData, useDataModule } from '@perpay-web/data-module/useDataModule';
import { useReduxDataModuleHookConnection } from '@perpay-web/data-module/useReduxDataModuleHookConnection';
import { PAYCHEX_DEDUCTIONS_ENDPOINT } from '@perpay-web/fintech/constants/urls';
import { useActionObservableCallback } from '@perpay-web/hooks/useActionObservableCallback';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

export const {
    dataRequest: createPayrollDeduction,
    dataSuccess: createPayrollDeductionSuccess,
    dataError: createPayrollDeductionError,
    dataReset: createPayrollDeductionReset,
} = createDataModuleActions('CREATE_PAYCHEX_DEDUCTION');

export const createPayrollDeductionSetAmount = createAction(
    'CREATE_PAYROLL_DEDUCTION::SET_DEDUCTION_AMOUNT',
);

const useCreatePaychexDeduction = () => {
    const dataModule = useDataModule((payload) =>
        authenticatedJsonFetch(
            PAYCHEX_DEDUCTIONS_ENDPOINT,
            payload,
            HTTPMethod.post,
        ),
    );

    return dataModule;
};

const getIsPaychexUser = (unusedState) => true;

const getWasInstantShipped = (state) =>
    getData(state) && getData(state).wasInstantShipped;

const useCreatePayrollDeduction = () => {
    const isPaychexUser = useSelector(getIsPaychexUser);
    const paychexHook = useCreatePaychexDeduction();
    // const paylocityHook = useCreatePaylocityDeduction();

    let dataModule;
    if (isPaychexUser) {
        dataModule = paychexHook;
    }

    // if (isPaylocityUser) {}

    if (!dataModule) {
        throw new Error(
            'user payroll payment setup provider could not be determined',
        );
    }

    useReduxDataModuleHookConnection({
        dataModule,
        hookAction$,
        request: createPayrollDeduction,
        error: createPayrollDeductionError,
        success: createPayrollDeductionSuccess,
        reset: createPayrollDeductionReset,
    });

    const [deductionAmount, setDeductionAmount] = useState(0);

    useActionObservableCallback(
        hookAction$,
        createPayrollDeductionSetAmount().type,
        (value) => setDeductionAmount(value),
    );

    return {
        ...dataModule,
        deductionAmount,
        wasInstantShipped: getWasInstantShipped(dataModule.state),
    };
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const dataModule = useCreatePayrollDeduction();

        return (
            <Context.Provider value={dataModule}>{children}</Context.Provider>
        );
    };

    return Provider;
};

export const [
    CreatePayrollDeductionDeductionDataModuleProvider,
    useCreatePayrollDeductionContext,
] = createContextProvider(providerFactory);
